import { pdf } from '@react-pdf/renderer';
import React from 'react';
import { DevelopmentPlanPdf, FormData } from '../DevelopmentPlanPdf';

function downloadBlob(filename: string, blob: Blob) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

export async function downloadDevelopmentPlanPdf(
  data: FormData,
  userName?: string | null
) {
  const doc = (
    <DevelopmentPlanPdf
      data={data}
      exportedAt={new Date()}
      userName={userName}
    />
  );
  const blob = await pdf(doc as any).toBlob();

  const stamp = new Date().toISOString().slice(0, 19).replace(/[:T]/g, '-');

  downloadBlob(`utviklingsplan-${stamp}.pdf`, blob);
}
